(() => {
  'use strict';

  const CAROUSELS = [
    {
      grid:
        '.pnwhy-question-grid',

      card:
        ':scope > .pnwhy-question',

      speed:
        72,

      direction:
        'left'
    },

    {
      grid:
        '.pnwhy-journey-grid',

      card:
        ':scope > .pnwhy-step',

      speed:
        76,

      direction:
        'left'
    },

    {
      grid:
        '.pnwhy-trust-grid',

      card:
        ':scope > .pnwhy-trust-card',

      speed:
        74,

      direction:
        'right',

      desktopOnly:
        true
    }
  ];


  const RESUME_DELAY =
    900;


  function initContinuousCarousel(
    grid,
    cardSelector,
    speed,
    direction = 'left',
    desktopOnly = false
  ) {

    if (
      desktopOnly &&
      !window.matchMedia(
        '(min-width: 1101px)'
      ).matches
    ) {
      return;
    }

    if (
      grid.dataset
        .pnwhyContinuousReady ===
      'true'
    ) {
      return;
    }


    const originals = [
      ...grid.querySelectorAll(
        cardSelector
      )
    ];


    if (originals.length < 2) {
      return;
    }


    grid.dataset
      .pnwhyContinuousReady =
        'true';


    originals.forEach(
      card => {

        const clone =
          card.cloneNode(true);


        clone.dataset
          .pnwhyClone =
            'true';


        clone.setAttribute(
          'aria-hidden',
          'true'
        );


        clone
          .querySelectorAll(
            'a, button, input, select, textarea, [tabindex]'
          )
          .forEach(
            element => {

              element.setAttribute(
                'tabindex',
                '-1'
              );

            }
          );


        grid.appendChild(
          clone
        );

      }
    );


    let lastTime = null;
    let paused = false;
    let resumeTimer = null;
    let loopWidth = 0;

    let rightDirectionReady =
      false;


    const reducedMotion =
      window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      );


    function firstClone() {

      return grid.querySelector(
        '[data-pnwhy-clone="true"]'
      );

    }


    function measureLoopWidth() {

      const first =
        originals[0];

      const clone =
        firstClone();


      if (
        !first ||
        !clone
      ) {

        loopWidth = 0;
        return;

      }


      loopWidth =
        clone.offsetLeft -
        first.offsetLeft;


      if (
        direction === 'right' &&
        !rightDirectionReady &&
        loopWidth > 0
      ) {

        grid.scrollLeft =
          loopWidth;

        rightDirectionReady =
          true;

      }

    }


    function normalize() {

      if (
        loopWidth <= 0
      ) {
        return;
      }


      if (
        direction === 'right'
      ) {

        if (
          grid.scrollLeft <= 1
        ) {

          grid.scrollLeft +=
            loopWidth;

        }


        while (
          grid.scrollLeft >
          loopWidth
        ) {

          grid.scrollLeft -=
            loopWidth;

        }

        return;
      }


      while (
        grid.scrollLeft >=
        loopWidth
      ) {

        grid.scrollLeft -=
          loopWidth;

      }

    }


    function frame(
      time
    ) {

      if (
        lastTime === null
      ) {
        lastTime = time;
      }


      const delta =
        Math.min(
          time - lastTime,
          50
        );


      lastTime = time;


      if (
        !paused &&
        !document.hidden &&
        !reducedMotion.matches
      ) {

        const distance =
          speed *
          (
            delta /
            1000
          );


        if (
          direction === 'right'
        ) {

          grid.scrollLeft -=
            distance;

        } else {

          grid.scrollLeft +=
            distance;

        }


        normalize();

      }


      window.requestAnimationFrame(
        frame
      );

    }


    function pause() {

      paused = true;

      window.clearTimeout(
        resumeTimer
      );

    }


    function resumeSoon() {

      window.clearTimeout(
        resumeTimer
      );


      resumeTimer =
        window.setTimeout(
          () => {

            measureLoopWidth();
            normalize();

            paused = false;

          },
          RESUME_DELAY
        );

    }


    function interactionPause() {

      pause();
      resumeSoon();

    }


    grid.addEventListener(
      'pointerdown',
      pause,
      {
        passive: true
      }
    );


    grid.addEventListener(
      'pointerup',
      resumeSoon,
      {
        passive: true
      }
    );


    grid.addEventListener(
      'pointercancel',
      resumeSoon,
      {
        passive: true
      }
    );


    grid.addEventListener(
      'touchstart',
      pause,
      {
        passive: true
      }
    );


    grid.addEventListener(
      'touchend',
      resumeSoon,
      {
        passive: true
      }
    );


    grid.addEventListener(
      'wheel',
      interactionPause,
      {
        passive: true
      }
    );


    grid.addEventListener(
      'focusin',
      pause
    );


    grid.addEventListener(
      'focusout',
      resumeSoon
    );


    const observer =
      new ResizeObserver(
        () => {

          measureLoopWidth();
          normalize();

        }
      );


    observer.observe(
      grid
    );


    originals.forEach(
      card => {

        observer.observe(
          card
        );

      }
    );


    window.addEventListener(
      'load',
      measureLoopWidth,
      {
        once: true
      }
    );


    measureLoopWidth();


    window.requestAnimationFrame(
      frame
    );

  }


  function boot(
    root = document
  ) {

    CAROUSELS.forEach(
      config => {

        root
          .querySelectorAll(
            config.grid
          )
          .forEach(
            grid => {

              initContinuousCarousel(
                grid,
                config.card,
                config.speed,
                config.direction,
                config.desktopOnly
              );

            }
          );

      }
    );

  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      () => boot()
    );

  } else {

    boot();

  }


  document.addEventListener(
    'shopify:section:load',
    event => {

      boot(
        event.target
      );

    }
  );

})();
